
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/maintenance",
      function () {
        return require("private-next-pages/maintenance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/maintenance"])
      });
    }
  